import { useEffect, useState } from 'react'
import logo from "../images/logo.svg";
import ClipLoader from "react-spinners/ClipLoader";

export default function SignIn() {

    const [ loading, setLoading ] = useState(true)

    const [ email, setEmail ] = useState('')
    const [ errMsg, setErrMsg ] = useState('')
    const [ password, setPassword ] = useState('')
    const [ name, setName ] = useState('')
    
    let handleInput = (e) => {
        switch (e.target.id) {
            case 'email':
            setEmail(e.target.value);
            break;
            
            case 'password':
            setPassword(e.target.value);
            break;
            
            case 'name':
            setName(e.target.value);
            break;
            
            default:
            alert('sorry, unknown field');
            break;
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }, [])

    const submit = (e) => {
        e.preventDefault()

        if (password === '' || email === '' || name === '') {
            setErrMsg('All fields are required')
            setTimeout(() => {
                setErrMsg('')
            }, 3000);
        } else {
            setErrMsg('Sorry, could not connect to server')
            setTimeout(() => {
                setErrMsg('')
            }, 3000);

        }
    }

 
    return (
        <>
            { loading ? 
                <div className="loader">
                    <ClipLoader color="#fdc51c" loading={loading} size={80} /> 
                </div> :
                <section className="row">
                    <section className="col-md-6 p-md-3 px-md-5 pull-up">
                        <div className="w-75 mx-auto my-md-0 my-4">
                            <div className="logo">
                                <img src={logo} alt="logo" />
                                <span className="logo-txt">Flash</span>
                            </div>
                            <div>
                                <h1 className="auth-title mb-4">Create Account</h1>
                                <form action="">
                                    <div className="form-group mb-3">
                                        <label htmlFor="name" className="font-weight-bold mb-2">Full Name</label>
                                        <div className="input form-control border-secondary">
                                            <i className="ri-user-line ri-lg px-2 w-25"></i> 
                                            <input type="name" onChange={handleInput} value={name} id="name" placeholder="Full Name" className="w-80 p-2 ps-0" />
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="password" className="font-weight-bold mb-2">Password</label>
                                        <div className="input form-control border-secondary">
                                            <i className="ri-lock-line ri-lg px-2 w-25"></i> 
                                            <input type="password" onChange={handleInput} value={password} id="password" placeholder="Password" className="w-80 p-2 ps-0" />
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="email" className="font-weight-bold mb-2">Email Address</label>
                                        <div className="input form-control border-secondary">
                                            <i className="ri-mail-line ri-lg px-2 w-25"></i> 
                                            <input type="email" onChange={handleInput} value={email} id="email" placeholder="Email Address" className="w-80 p-2 ps-0" />
                                        </div>
                                    </div>
                                    {errMsg && <div className="alert alert-danger" style={{ position: 'fixed', top: '10px', left: '10px', opacity: 0.85 }}>{errMsg}</div> }

                                    <button className="submit-btn mt-3 p-3 form-control flash-bg text-uppercase fw-bold" onClick={submit}>create account</button>
                                </form>
                            </div>
                        </div>
                    </section>
                    <section className="col-md-6 px-0 d-none auth-side-img d-md-block"></section>
                </section>
            }
        </>
    )
}